import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'header-and-value',
  templateUrl: './header-and-value.component.html',
  styleUrls: ['./header-and-value.component.scss'],
})
export class HeaderAndValueComponent implements OnInit {
  @Input() header: string;
  @Input() value: string | number | boolean;
  @Input() type: 'date' | 'text' = 'text';
  @Input() color: string;
  @Input() ignoreValue = false;

  constructor(private datePipe: DatePipe) {}

  ngOnInit(): void {
    if (this.type === 'date' && typeof this.value === 'string') {
      this.value = this.value.replace(
        /([0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:(?:[0-9]{2}.)?(?:(?:[0-9]{2,7}Z)|(?:[0-9+]{3,7}:[0-9]{2})))/g,
        (str) => {
          return this.datePipe.transform(str, 'short');
        },
      );
    }
  }
}

export interface IHeaderAndValue {
  header: string;
  value: string | number | boolean;
  subheader?: string | number | boolean;
}
